import { render, staticRenderFns } from "./base-worker.vue?vue&type=template&id=1a6e207a&scoped=true&"
import script from "./base-worker.vue?vue&type=script&lang=js&"
export * from "./base-worker.vue?vue&type=script&lang=js&"
import style0 from "./base-worker.vue?vue&type=style&index=0&id=1a6e207a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6e207a",
  null
  
)

export default component.exports